import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 中文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import './utils/rem.js'
import 'animate.css'
import VueGtag from 'vue-gtag';

Vue.config.productionTip = false
Vue.use(ElementUI,{zhLocale})
Vue.use(VueGtag, {
	appName: 'xwg.games',
	pageTrackerScreenviewEnabled: true,
	config: {
		id: 'G-J8LQYF1RHZ'
	},
}, router);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
